<template>
	<div class="goods">
		<van-swipe class="goods-swipe" :autoplay="3000">
			<van-swipe-item>
				<img :src="order.cover" />
			</van-swipe-item>
		</van-swipe>

		<van-row>
			<van-col offset="6" span="12">
				<div class="book-name">{{ order.bookName }}</div>
			</van-col>
		</van-row>
		<van-row>
			<van-col offset="6" span="12">
				<div class="book-author">作者:&nbsp;{{ order.author }}</div>
			</van-col>
		</van-row>
		<van-row>
			<van-col offset="6" span="12">
				<div class="book-publisher">出版社:&nbsp;{{ order.publisher }}</div>
			</van-col>
		</van-row>

		<van-row>
			<van-col offset="6" span="12">
				<div class="book-publisher">
					<span class="book-rate">{{ rate }}</span>
					<van-rate
						v-model="rate"
						allow-half
						void-icon="star"
						void-color="#eee"
					/>
				</div>
			</van-col>
		</van-row>

		<van-row>
			<van-col offset="6" span="12">
				<div class="book-times">
					<span class="book-borrow-times">借阅次数({{ borrowTimes }})</span>
					<span class="book-evaluate-times">图书评价({{ evaluateTimes }})</span>
				</div>
			</van-col>
		</van-row>

		<van-row>
			<van-col offset="0" span="20">
				<van-tag class="book-tag" round plain>3~6岁</van-tag>
				<van-tag class="book-tag" round plain>儿童绘本</van-tag>
			</van-col>
		</van-row>

		<van-divider />

		<van-goods-action>
			<van-goods-action-button type="danger" @click="borrowNow">
				立即借阅
			</van-goods-action-button>
		</van-goods-action>

		<van-popup
			v-model="showCode"
			closeable
			close-icon="close"
			position="bottom"
			:style="{ height: '60%' }"
		>
			<van-row>
				<van-col offset="6" span="12">
					<div class="book-code">{{ code }}</div>
					<div class="book-code-title">{{ codeTitle }}</div>
				</van-col>
			</van-row>
			<van-row>
				<van-col offset="6" span="12">
					<div class="book-tip">
						{{ tip }}
					</div>
				</van-col>
			</van-row>
		</van-popup>
	</div>
</template>

<script>
import {
	Tag,
	Col,
	Icon,
	Cell,
	CellGroup,
	Swipe,
	Toast,
	SwipeItem,
	GoodsAction,
	GoodsActionIcon,
	GoodsActionButton,
	Rate,
	Row,
	Divider,
	Popup,
	Dialog,
} from "vant";

import wx from "weixin-jsapi";
import { Get, Post } from "@/utils/Api";

export default {
	components: {
		[Tag.name]: Tag,
		[Col.name]: Col,
		[Icon.name]: Icon,
		[Cell.name]: Cell,
		[CellGroup.name]: CellGroup,
		[Swipe.name]: Swipe,
		[SwipeItem.name]: SwipeItem,
		[GoodsAction.name]: GoodsAction,
		[GoodsActionIcon.name]: GoodsActionIcon,
		[GoodsActionButton.name]: GoodsActionButton,
		[Rate.name]: Rate,
		[Row.name]: Row,
		[Divider.name]: Divider,
		[Popup.name]: Popup,
		[Dialog.Component.name]: Dialog.Component,
	},
	data() {
		return {
			orderId: null,
			order: {},
			rate: 4.5,
			borrowTimes: 365,
			evaluateTimes: 1688,
			showCode: false,
			code: "XXXXXX",
			codeTitle: "提取码",
			tip: "请使用[ 提取码 ]取书,同时[ 提取码 ]会发送到您的微信上,请注意查收!",
			userInfo: null,
		};
	},
	mounted: function() {
		console.log("mounted");
		this.orderId = this.$route.params.orderId;
		console.log(" orderId ", this.orderId);

		this.getBookDetail();
		this.getUserInfo();
		this.getWeChatParams();
	},

	methods: {
		getBookDetail() {
			Get(
				"order/queryDetail",
				{
					id: this.orderId,
				},
				(res) => {
					console.log("order detail", res.data.data);
					this.order = res.data.data;
				},
				(res) => {
					console.log("ERROR", res);
				}
			);
		},
		getWeChatParams() {
			console.log("getWeChatParams");
			Get(
				"getWeChatParams",
				{},
				(r) => {
					console.log("getWeChatParams", r);
					var data = r.data.data;
					wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
						appId: data.appId, // 必填，公众号的唯一标识
						timestamp: data.timestamp, // 必填，生成签名的时间戳
						nonceStr: data.nonceStr, // 必填，生成签名的随机串
						signature: data.signature, // 必填，签名
						jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表
					});
					wx.ready(function() {
						console.log("Check JSAPI");
						wx.checkJsApi({
							jsApiList: ["chooseWXPay"],
							success: function(res) {
								console.log("success");
								console.log(res);
							},
							fail: function(res) {
								console.log("fail");
								console.log(res);
							},
						});
					});
				},
				(r) => {
					console.log(r);
				}
			);
		},
		getUserInfo() {
			//加载用户信息
			var openId = localStorage.getItem("openId");
			Get(
				"getCurrentUserInfo",
				{
					openId: openId,
				},
				(res) => {
					var data = res.data.data;
					if (data.length > 0) {
						this.userInfo = data[0];
					}
					console.log("用户信息", data);
				},
				(res) => {
					console.log("ERROR", res);
				}
			);
		},

		getCode() {
			var openId = localStorage.getItem("openId");
			Post(
				"order/getCode",
				{
					id: this.orderId,
					openId: openId,
				},
				(res) => {
					var result = res.data;

					console.log("order detail", result);
					if (result.success) {
						this.code = result.data.code;
						this.showCode = true;
					} else {
						Toast(result.msg);
					}
				},
				(res) => {
					console.log("ERROR", res);
				}
			);
		},

		payOnce() {
			var openId = localStorage.getItem("openId");
			Post(
				"pay/once",
				{
					openId: openId,
				},
				(res) => {
					var r = res.data;
					if (r.success) {
						wx.chooseWXPay({
							appId: r.data.appId,
							timestamp: r.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
							nonceStr: r.data.nonceStr, // 支付签名随机串，不长于 32 位
							package: r.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
							signType: r.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
							paySign: r.data.sign, // 支付签名
							success: function(res) {
								// 支付成功后的回调函数
								//alert(res);
								//Toast.success(res);
								console.log(res);
								this.getCode();
							},
							// 支付取消回调函数
							cencel: function(res) {
								Toast.fail("用户取消支付~", res);
							},
							// 支付失败回调函数
							fail: function(res) {
								Toast.fail("支付失败~", res);
							},
						});
					}
					console.log("预支付请求", r);
				},
				(res) => {
					console.log("ERROR", res);
				}
			);
		},

		borrowNow() {
			Dialog.confirm({
				title: "消息确认",
				message: "确认要借阅 [" + this.order.bookName + "] 吗?",
			})
				.then(() => {
					// on confirm
					var openId = localStorage.getItem("openId");

					// 2.如果学校设置按次付费, 需要支付之后才可以借书
					var payType = this.userInfo.payType;
					if (payType == 3) {
						// 3.是否已支付订单
						Post(
							"hasPayOrder",
							{
								id: this.orderId,
								openId: openId,
							},
							(res) => {
								var result = res.data;

								console.log("hasPayOrder", result);

								//已支付
								if (result.success) {
									this.getCode();
								} else {
									//未支付
									//调起支付接口, 支付成功之后会调起获取借书码
									this.payOnce();
								}
							},
							(res) => {
								console.log("ERROR", res);
							}
						);
					} else {
						// 3.获取借书码, 并打开书格
						this.getCode();
					}
				})
				.catch(() => {
					// on cancel
				});
		},
	},
};
</script>

<style lang="less">
.book-name {
	font-size: 20px;
	font-weight: bolder;
	text-align: center;
	margin: 10px 0 10px 0;
}

.book-author {
	color: #8888ff;
	text-align: center;
}

.book-publisher {
	text-align: center;
}

.book-rate {
	font-size: 20px;
	margin-right: 10px;
}

.book-times {
	font-size: 12px;
	text-align: center;
	color: #888888;
	margin: 10px 0 10px 0;
}

.book-borrow-times {
	margin-right: 20px;
}

.book-tag {
	margin-left: 10px;
	padding: 5px 10px 5px 10px;
}

.book-code,
.book-code-title,
.book-tip {
	margin: 10px;
	text-align: center;
}

.book-code {
	font-size: 30px;
	font-weight: bolder;
}

.book-code-title {
	font-size: 20px;
	font-weight: bolder;
}

.book-tip {
	color: #888888;
}

.goods {
	padding-bottom: 50px;

	background-color: #ffffff;

	&-swipe {
		img {
			width: 100%;
			display: block;
		}
	}

	&-title {
		font-size: 16px;
	}

	&-price {
		color: #f44;
	}

	&-express {
		color: #999;
		font-size: 12px;
		padding: 5px 15px;
	}

	&-cell-group {
		margin: 15px 0;

		.van-cell__value {
			color: #999;
		}
	}

	&-tag {
		margin-left: 5px;
	}
}
</style>
